/**
 *
 * @param {Event} event The event to prevent any undesired behavior
 * @param {string} element Selector for the target we want to focus
 * @param {HTMLElement} parent The outer element where our target lives default = document.
 * https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus
 *
 */
export const focusElement = (event, element, parent = document) => {
  if (!element) {
    throw new Error("Missing selector for the target we want to focus")
  }

  if (event) {
    event.preventDefault()
    event.stopPropagation()
  }

  // in case the element is still not present on parent
  setTimeout(() => {
    parent.querySelector(element).focus()
  }, 0)
}
